import { useState } from 'react';
import { caseList, topicTabs } from '@/mocks/homeData';

export default function CaseCollection() {
  const [activeTab, setActiveTab] = useState('all');

  const filtered = activeTab === 'all' ? caseList : caseList.filter((c) => c.category === activeTab);

  return (
    <section id="cases" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl mb-8 md:mb-10">
          <span className="text-xs font-medium tracking-widest text-primary-600 uppercase">
            相似案例合集
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3 mb-4">
            按主题聚合，快速找到可比照的案例
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            需要参照物的时候，不用一条条翻。先选主题，再从集合里挑一个结构最接近的案例对照着看。
          </p>
        </div>

        <div className="flex flex-wrap gap-2 mb-8">
          {topicTabs.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-2 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-700 border border-background-300 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {filtered.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors flex flex-col"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title}相似案例合集配图`}
                  title={`${item.title} · 同类事件对比与横向比较分析`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-background-50/95 text-xs font-medium text-foreground-800 backdrop-blur-sm whitespace-nowrap">
                  {item.categoryLabel}
                </span>
                <span
                  className={`absolute top-3 right-3 px-2.5 py-1 rounded-md text-xs font-medium backdrop-blur-sm whitespace-nowrap ${
                    item.status === '跟踪中'
                      ? 'bg-primary-500/95 text-background-50'
                      : 'bg-secondary-500/95 text-background-50'
                  }`}
                >
                  {item.status}
                </span>
              </div>

              <div className="flex-1 flex flex-col p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">{item.summary}</p>

                <div className="flex flex-wrap gap-2 mb-4">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-[11px] text-secondary-800 bg-secondary-100 rounded-full px-2.5 py-1 whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-background-200">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-600">
                    <i className="ri-fire-line text-primary-500"></i>
                    关注度 {item.heat}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <div className="text-center py-16 text-sm text-foreground-500">
            该主题下暂时没有收录案例，换个主题看看。
          </div>
        )}
      </div>
    </section>
  );
}